import { useTheme } from "./useTheme";

import backgroundDark from "~/assets/onboarding/background-dark.svg";
import backgroundLight from "~/assets/onboarding/background.svg";
import companyNameDark from "~/assets/onboarding/company-name-dark.svg";
import companyNameLight from "~/assets/onboarding/company-name.svg";
import createAccountDark from "~/assets/onboarding/create-account-dark.svg";
import createAccountLight from "~/assets/onboarding/create-account.svg";
import passwordDark from "~/assets/onboarding/password-dark.svg";
import passwordLight from "~/assets/onboarding/password.svg";
import pipelineModeDark from "~/assets/onboarding/pipeline-mode-dark.svg";
import pipelineModeLight from "~/assets/onboarding/pipeline-mode.svg";
import successLight from "~/assets/onboarding/success.svg";

type OnboardingImageKey =
  | "background"
  | "company-name"
  | "create-account"
  | "password"
  | "pipeline-mode"
  | "success";

const imageMap: Record<OnboardingImageKey, { light: string; dark: string }> = {
  background: { light: backgroundLight, dark: backgroundDark },
  "company-name": { light: companyNameLight, dark: companyNameDark },
  "create-account": { light: createAccountLight, dark: createAccountDark },
  password: { light: passwordLight, dark: passwordDark },
  "pipeline-mode": { light: pipelineModeLight, dark: pipelineModeDark },
  success: { light: successLight, dark: successLight },
};

export function useThemedOnboardingImage(key: OnboardingImageKey): string {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  return isDark ? imageMap[key].dark : imageMap[key].light;
}

export function getThemedOnboardingImages(isDark: boolean) {
  return {
    background: isDark ? backgroundDark : backgroundLight,
    companyName: isDark ? companyNameDark : companyNameLight,
    createAccount: isDark ? createAccountDark : createAccountLight,
    password: isDark ? passwordDark : passwordLight,
    pipelineMode: isDark ? pipelineModeDark : pipelineModeLight,
    success: successLight,
  };
}
